// A class to handle palette retrieval and operations from a given layer group

var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.Palette = new Class({
    Implements: [Options],
    class_type: "Palette",
    class_name: "Palette",
    lookup_cache: {},
    index_cache: {},
    max_index: 0,
    min_index: 0,
    lookup_coefficent: 0,
    color_curve: [],
    options: {
        max_val: 0,
        min_val: 0,
        color_gradient: [],
        cache_results: false
    },
    initialize: function (op) {
        if (op && op.color_gradient) {
            op.color_gradient = this.set_color_gradient(op.color_gradient);
        }
        this.setOptions(op);
        this.create_color_lookup_coefficient();
    },
    clone: function () {
        return new OCS.Viewer.Classes.Palette(this.options);
    },
    set_color_gradient: function (in_cg) {
        var grad_obj;
        var cg = [];
        in_cg.each(function (color, index) {
            if (OCS.Utilities.is_string(color)) {
                grad_obj = {"color": color, "index": index};
            }
            if (OCS.Utilities.is_object(color)) {
                grad_obj = color;
            }
            if (grad_obj) {
                cg.push(grad_obj);
            }
            grad_obj = null;
        }.bind(this));
        this.options.color_gradient = OCS.Utilities.gradient_fill(cg);
        this.reset();
        return this.options.color_gradient;
    },
    set_max_val: function (val) {
        this.options.max_val = val;
        this.create_color_lookup_coefficient();
    },
    set_min_val: function (val) {
        this.options.min_val = val;
        this.create_color_lookup_coefficient();
    },
    get_color_curve: function () {
        if (!this.color_curve.length && this.options.color_gradient.length) {
            this.options.color_gradient.each(function (color, index) {
                this.color_curve.push(color.color);
            }.bind(this));
        }
        return this.color_curve;
    },
    get_color_from_value: function (value) {
        if (!this.lookup_cache['' + value]) {
            if (this.options.cache_results) {
                this.lookup_cache['' + value] = this.get_color(this.get_index(value));
            } else {
                return this.get_color(this.get_index(value));
            }
        }
        return this.lookup_cache['' + value];
    },
    get_color_gradient: function () {
        return this.options.color_gradient;
    },
    /**
     * Returns back an associated value based on a passed in color
     * @param {String} color
     * @return {Number} value
     */
    get_value_from_color: function (color) {
        return Object.keyOf(this.lookup_cache, color);
    },
    get_index: function (value) {
        var index;
        if (!this.index_cache["" + value]) {
            index = Math.min(Math.max(Math.round((Math.min(Math.max(value, this.options.min_val), this.options.max_val) - this.options.min_val) * this.lookup_coefficent), 0), this.max_index);
            if (this.options.cache_results) {
                this.index_cache["" + value] = index;
                if (isNaN(this.index_cache["" + value])) {
                    console.warn("Nan found!");
                }
            } else {
                return index;
            }
        }
        return this.index_cache["" + value];
    },
    get_index_from_color: function (color) {
        return this.color_curve.indexOf(color);
    },
    get_frac: function (index) {
        return index / (this.options.color_gradient.length - 1);
    },
    get_color: function (index) {
        var colors = this.get_color_gradient();
        return colors[index].color;
    },
    create_color_lookup_coefficient: function () {
        var colors = this.get_color_gradient();
        this.max_index = colors.length - 1;
        var range = this.options.max_val - this.options.min_val;
        this.lookup_coefficent = this.max_index / range;
    },
    clear_cache: function () {
        this.lookup_cache = {};
        this.index_cache = {};
    },
    reset: function () {
        this.clear_cache();
        this.lookup_coefficent = 0;
        this.max_index = 0;
        this.color_curve = [];
    }

});